<template lang="pug">
.container-restricao
    .card-restricao(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido !== "undefined" && restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='selecionarRestricao')
        p
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.categoria') }}:
            |
            | {{ restricao?.cam || restricao?.properties?.cam || '-' }}
            br
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.juridicao') }}:
            |
            | {{ restricao?.fna || restricao?.properties?.fna || '-' }}
            br
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.classe') }}:
            |
            | {{ restricao?.nam || restricao?.properties?.nam || '-' }}
            br
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.data') }}:
            |
            | {{ restricao?.dct || restricao?.properties?.dct || '-' }}
            br
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.autoridadeResp') }}:
            |
            | {{ restricao?.sag || restricao?.properties?.sag || '-' }}
            br
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.sup_ha') }}:
            |
            | {{ restricao?.areaTotalFeatureHa ? Number(restricao.areaTotalFeatureHa).toFixed(2) : restricao?.properties?.areaTotalFeatureHa ? Number(restricao.properties.areaTotalFeatureHa).toFixed(2) : '-' }}
            br

            Criticidade(v-if='restricao.nivelAlerta', :restricao='restricao')
</template>

<script>
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';

export default {
    name: 'OtbnArgentina',

    components: {
        Criticidade
    },
    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>
